var map = {
	"./instagram-1.jpg": 44822,
	"./instagram-10.jpg": 26961,
	"./instagram-11.jpg": 94699,
	"./instagram-12.jpg": 12225,
	"./instagram-13.jpg": 63449,
	"./instagram-14.jpg": 96645,
	"./instagram-15.jpg": 52673,
	"./instagram-16.jpg": 44177,
	"./instagram-17.jpg": 33621,
	"./instagram-18.jpg": 81068,
	"./instagram-2.jpg": 63106,
	"./instagram-3.jpg": 5989,
	"./instagram-4.jpg": 15492,
	"./instagram-5.jpg": 95760,
	"./instagram-6.jpg": 23923,
	"./instagram-7.jpg": 15022,
	"./instagram-8.jpg": 59757,
	"./instagram-9.jpg": 58067,
	"./instagram-md-1.jpg": 2683,
	"./instagram-md-10.jpg": 55547,
	"./instagram-md-11.jpg": 29187,
	"./instagram-md-12.jpg": 14120,
	"./instagram-md-2.jpg": 62023,
	"./instagram-md-3.jpg": 25549,
	"./instagram-md-4.jpg": 55952,
	"./instagram-md-5.jpg": 8677,
	"./instagram-md-6.jpg": 4087,
	"./instagram-md-7.jpg": 61915,
	"./instagram-md-8.jpg": 78074,
	"./instagram-md-9.jpg": 20103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41042;